import { isMobile } from 'react-device-detect';
import { matchPath, useLocation } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { FF_MOBILE_SIGNUP_HANDOFF, FF_WEAVE_TOOLS_MOBILE } from '@/consts/featureFlags';
import { isMobileSignupHandoffRoute } from '@/consts/mobileHandoff.consts';
import { AuthContext } from '@/contexts/AuthContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { MobileSignupHandoffPage } from './MobileSignupHandoffPage/MobileSignupHandoffPage';
import { MobileUnsupportedPage } from './MobileUnsupportedPage/MobileUnsupportedPage';

type WithMobileCheckProps = {
  children: React.JSX.Element;
  excludedPaths?: string[];
};

export const MobileCheck = ({ children, excludedPaths = [] }: WithMobileCheckProps): React.JSX.Element => {
  const location = useLocation();
  const { currentUser } = useContext(AuthContext);
  const { value: isMobileSignupHandoffEnabled } = useFeatureFlag(FF_MOBILE_SIGNUP_HANDOFF);
  const { value: isToolsMobileEnabled } = useFeatureFlag(FF_WEAVE_TOOLS_MOBILE);

  const isExcluded =
    excludedPaths.includes(location.pathname) ||
    (isToolsMobileEnabled === true && !!matchPath('/tool/:toolId', location.pathname));
  const shouldShowSignupHandoff = useMemo(() => {
    return Boolean(currentUser) && isMobileSignupHandoffRoute(location.pathname, location.search);
  }, [currentUser, location.pathname, location.search]);

  if (!isExcluded && isMobile) {
    if (isMobileSignupHandoffEnabled === true && shouldShowSignupHandoff) {
      return <MobileSignupHandoffPage />;
    }

    return <MobileUnsupportedPage />;
  }

  return children;
};
